module.exports = __webpack_public_path__ + "img/4.b225df67.png";